import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchVendorPerformance = createAsyncThunk(
  "vendorReport/fetchVendorPerformance",
  async ({ limit = 5 } = {}, thunkAPI) => {
    try {
      const res = await api.get(`/api/vendors/performance-report?limit=${limit}`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch vendor performance report"
      );
    }
  }
);

export const fetchVendorDetail = createAsyncThunk(
  "vendorReport/fetchVendorDetail",
  async (vendorId, thunkAPI) => {
    try {
      const res = await api.get(`/api/vendors/${vendorId}/detail`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to fetch vendor detail"
      );
    }
  }
);

export const createManualPayout = createAsyncThunk(
  "vendorReport/createManualPayout",
  async ({ vendorId, amount }, thunkAPI) => {
    try {
      const res = await api.post(`/api/vendors/${vendorId}/manual-payout`, {
        amount,
      });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to add manual payout"
      );
    }
  }
);

const vendorReportSlice = createSlice({
  name: "vendorReport",
  initialState: {
    vendors: [],
    loading: false,
    error: null,

    detail: null,
    detailLoading: false,
    detailError: null,

    manualPayoutSubmitting: false,
    manualPayoutError: null,
  },
  reducers: {
    clearVendorDetail: (state) => {
      state.detail = null;
      state.detailError = null;
    },
    clearManualPayoutError: (state) => {
      state.manualPayoutError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorPerformance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorPerformance.fulfilled, (state, action) => {
        state.loading = false;
        state.vendors = action.payload;
      })
      .addCase(fetchVendorPerformance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchVendorDetail.pending, (state) => {
        state.detailLoading = true;
        state.detailError = null;
      })
      .addCase(fetchVendorDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detail = action.payload;
      })
      .addCase(fetchVendorDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.detailError = action.payload;
      })

      .addCase(createManualPayout.pending, (state) => {
        state.manualPayoutSubmitting = true;
        state.manualPayoutError = null;
      })
      .addCase(createManualPayout.fulfilled, (state) => {
        state.manualPayoutSubmitting = false;
      })
      .addCase(createManualPayout.rejected, (state, action) => {
        state.manualPayoutSubmitting = false;
        state.manualPayoutError = action.payload;
      });
  },
});

export const { clearVendorDetail, clearManualPayoutError } = vendorReportSlice.actions;
export default vendorReportSlice.reducer;